/**
 * @author: chenlv
 * @date: 2025/01/22
 * @description: 表格展示列Segment组件
 */
import React, { useMemo } from 'react';
import classnames from 'classnames';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { Segment } from 'tea-component';
import { TABLE_SEGMENT_OPTIONS, DEFAULT_TABLE_SEGMENT } from './constants';

import type { TTableSegment } from '../../types';

import './index.scss';

interface ITableSegmentProps extends IBaseProps {
  /** 当前选中值 */
  value?: TTableSegment;
  /** 变更回调 */
  onChange?: ((value: TTableSegment) => void) | null;
}

/**
 * TableSegment 表格展示列Segment组件
 * @description 用于切换表格展示的数据类型（Metrics/Top Games/Rising Games）
 */
const TableSegment: React.FC<ITableSegmentProps> = (props) => {
  const { style, className, value = DEFAULT_TABLE_SEGMENT, onChange } = props;

  const { formatMessage } = useIntlExtend();

  /**
   * 转换为 Segment 组件需要的格式
   */
  const segmentOptions = useMemo(() => {
    return TABLE_SEGMENT_OPTIONS.map((option) => {
      return {
        value: option?.value || '',
        text: formatMessage({ id: option?.i18nKey || '' }),
      };
    });
  }, [formatMessage]);

  /**
   * 处理Segment变更
   */
  const handleChange = (payload: string): void => {
    if (payload !== value) {
      onChange?.(payload as TTableSegment);
    }
  };

  return (
    <div style={style} className={classnames('dbi-table-segment', className)}>
      <Segment options={segmentOptions} value={value} onChange={handleChange}  className="segment-light"/>
    </div>
  );
};

export default TableSegment;
